import req from './http.js'
import f_download_http from './f_download_http.js'

// 登入
export const apiLogin = params => req('post', '/user/userLogin', params)

// 發送重設信件的
export const apiSendResetEmail = params => req('post', '/user/resetPassword', params)

// 重設密碼&檢查重設密碼信件的token
export const apiResetPwd = params => req('patch','/user/doResetPassword', params)

// 註冊帳號
export const apiRegister = params => req('post', '/user/register', params)

// 用token檢查使用者是不是合法使用者
export const apiCheckLogin = () => req('get', '/user/getUserInfo')

export const apiCheckLoginWithData = () => req(
    'get', '/user/getUserInfo'
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 設定預設值的api，基本上就是存一包JSON跟行銷圖卡的add_column有異曲同工之妙
export const apiUpdateDefult = (params) => req('post', '/user/updateDefault', params)

export const apiUpdateDefultWithData = (params) => req('post', '/user/updateDefault', params).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

// 新版登入，透過SHOPLINE跳轉過來，只有PRODUCTION環境會用這個方式登入
export const apiSLogin = params => req('post', '/user/slUserLogin', params)

// 更新token時效
export const apiRefreshToken = () => req('post', '/user/refresh')

// 取Batch LIST
export const apiGetUserBatchList = (org_id, container_id, page, limit) => req(
    'get',
    `/userbatch?container_id=${container_id}&page=${page}&limit=${limit}&org=${org_id}`
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiDownloadBatch = (org_id, job_id) => f_download_http(
    'get',
    `/userbatch/download?job_id=${job_id}&org=${org_id}`
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiCyberbizInstallLogin = (params) => req(
    'post', '/cyberbiz/install', params
).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

export const apiCyberbizAuth = (params) => req(
    'post', '/cyberbiz/auth', params
).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

export const apiUseApiAuth = (payload) => req('post', '/user/checkApiAuth', payload)
  .then((res) => {
    if (res.data.code === 200) {
      return res.data.data
    }
      throw new Error('查看權限資料失敗')
  }).catch((error) => {
      throw error
  })

